export const tr = {
    manager: 'Yönetici',
    'support-phone': "Destek Ekibi'ne"
};
